import { ModalType, useModalContext } from 'modules/campaigns/editor/context';
import { DestructiveButton, BUTTON_SIZES } from 'ui/button';
import { Stop } from 'ui/icons';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const AbortCampaignAction = () => {
  const { openModal } = useModalContext();

  return (
    <CampaignPermissionCheck action="abort" ChildWrapper={CampaignPopover}>
      <DestructiveButton
        data-test="abort-button"
        size={BUTTON_SIZES.LARGE}
        onClick={() => openModal(ModalType.AbortCampaignModal)}
      >
        <Stop height={20} />
        Abort campaign
      </DestructiveButton>
    </CampaignPermissionCheck>
  );
};
